package com.siriusxm.pia.views.unifiedaggregator.management

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.siriusxm.pia.components.tabView
import com.siriusxm.pia.views.unifiedaggregator.AggregatorService
import com.siriusxm.pia.views.unifiedaggregator.events.EventFilters
import com.siriusxm.pia.views.unifiedaggregator.events.GroupedInvalidEvents

/**
 * The all-producers aggregate view: invalid events across every producer, grouped by error reason.
 *
 * Unlike the per-producer Errors tab, the filters here are held in plain component state rather than in
 * the URL. This view has no URL of its own to write to — it is what the producers list shows when the
 * synthetic "All" row is selected, which is `#aggregator/producers` with no producer id, and the
 * selection itself is local state (`showAll` in [producers]). Writing `?range=…` against a path that
 * does not encode "All" would produce a link that restores the filter but not the view it filtered.
 * Making the shared view controlled is what lets this page opt out without a mode flag.
 */
@Composable
fun ProducersDashboard(aggregator: AggregatorService) {
    var filters by remember { mutableStateOf(EventFilters()) }

    tabView {
        tab("Errors") {
            GroupedInvalidEvents(
                aggregator,
                showProducer = true,
                filters = filters,
                onFiltersChange = { filters = it }
            ) { range, queryId ->
                if (queryId != null) {
                    aggregator.clientApi.getProducersEvents(queryId = queryId)
                } else if (range != null) {
                    val range = range.range()
                    aggregator.clientApi.getProducersEvents(
                        range.start, range.endInclusive
                    )
                } else {
                    throw IllegalArgumentException()
                }
            }
        }
    }
}
